import React, { useContext } from 'react';
import { styled } from '@mui/material/styles';
import ToolbarSpacer from 'components/shared/ToolbarSpacer';
import ClipControl from './ClipControl';
import SeekControls from './SeekControls';
import VideoPlayer from './VideoPlayer';
import HighlightDetails from '../HighlightDetails';
import { VideoTrimmerContext } from './VideoTrimmerProvider';
import { Collapse } from '@mui/material';

const PREFIX = 'VideoTrimmer';

const classes = {
    root: `${PREFIX}-root`,
    videoControls: `${PREFIX}-videoControls`
};

const Root = styled('div')({
    [`&.${classes.root}`]: {
        display: 'block',
        color: '#102A43',
        '& .MuiFormLabel-root': {
            color: '#102A43'
        },
        '& .MuiInput-root': {
            color: '#102A43'
        }
    },

    [`& .${classes.videoControls}`]: {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#F0F4F8'
    }
});

const DoubleCollapse = ({ in: inProp, children }) => {
    return <Collapse
        in={inProp}
        orientation="horizontal"
        collapsedSize={500}
        timeout={300}
    >
        <Collapse
            in={inProp}
            orientation="vertical"
            timeout={300}
        >
            { children }
        </Collapse>
    </Collapse>;
};

const VideoTrimmer = () => {
    const {
        pageNumber
    } = useContext(VideoTrimmerContext);

    return (
        <Root className={classes.root}>
            <div>
                <DoubleCollapse in={pageNumber === 1}>
                    <div>
                        <VideoPlayer />
                        <div className={classes.videoControls}>
                            <SeekControls />
                            <ToolbarSpacer grow />
                            <ClipControl />
                        </div>
                    </div>
                </DoubleCollapse>
            </div>
            <div>
                <Collapse in={pageNumber === 2}>
                    <HighlightDetails />
                </Collapse>
            </div>
        </Root>
    );
};

export default VideoTrimmer;
